import { render, staticRenderFns } from "./QuotaholdersManagement.vue?vue&type=template&id=21bbedb2&"
import script from "./QuotaholdersManagement.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports